import React from 'react';
import MenuItemAnchor from './MenuItemAnchor';

function isVisible() {
    return Gaia.user.hasSubscription;
}

function Toolbar(props) {
    const {component:Component = 'a', ...restProps} = props;
    if (!isVisible()) return null;

    return (<Component {...restProps} href="https://help.gaiagps.com/" rel="noopener noreferrer" target="_blank">
        {gettext('Help')}
    </Component>);
}

function HamburgerMenu(props) {
    if (!isVisible()) return null;

    return <Toolbar component={MenuItemAnchor} {...props} />;
}

export default { Toolbar, HamburgerMenu };
